import useService from "@ipru-common/hooks/useService";
import { ApiName } from "@ipru-common/services/ApiEndpoints";
import { SUCCESS } from "@ipru-common/constants/SiteConstants";
import { useState } from "react";
import { generateGaVisitorID } from "@ipru-common/utils/CommonFunctions";

export default function usePostFeedBackService() {
  const [feedBackFormData, setFeedBackFormData] = useState([]);
  const [error, setError] = useState("");
  const { callService } = useService();

  const submitFeedback = async (data) => {
    const requestObject = {
      SurveyName: "Netcore Lead Survey",
      gaId: generateGaVisitorID(),
      clientId: "",
      versionNo: "01",
      q1: data?.q1 || "",
      q2: data?.q2 || "",
      q3: "",
      q4: "",
      q5: `Product Id : ${data?.calculatorFormData?.productCode || ""}`,
      q6: data?.calculatorFormData?.mobileno || "",
      q7: data?.calculatorFormData?.emailid || "",
    };
    const payload = {
      serviceId: "PSW37",
      requestObject: JSON.stringify(requestObject),
    };

    callService({
      params: {
        apiName: ApiName.FEEDBACK_FORM,
        method: "POST",
        data: payload,
      },
      loader: false,
    })
      .then((response) => {
        const { status, result } = response;

        if (status === SUCCESS) {
          setFeedBackFormData(result || []);
        }
      })
      .catch(() => {
        setError("Failed to submit feedback. Please try again later.");
      });
  };

  return { submitFeedback, feedBackFormData, error };
}
